/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Vc_Ft_6_DescInputs */

const en_vc_ft_6_desc = /** @type {(inputs: Vc_Ft_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengths, angles and radii that follow the artwork they measure, for technical drawings and product sheets.`)
};

const zh_vc_ft_6_desc = /** @type {(inputs: Vc_Ft_6_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`标注的长度、角度和半径会跟随图稿变化，适合技术图纸和产品说明图。`)
};

/**
* | output |
* | --- |
* | "Lengths, angles and radii that follow the artwork they measure, for technical drawings and product sheets." |
*
* @param {Vc_Ft_6_DescInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const vc_ft_6_desc = /** @type {((inputs?: Vc_Ft_6_DescInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Vc_Ft_6_DescInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_vc_ft_6_desc(inputs)
	return zh_vc_ft_6_desc(inputs)
});
export { vc_ft_6_desc as "vc.ft.6.desc" }